import { Link } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-foreground-50/5">
      <div className="px-4 md:px-8 py-12 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 group whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-background-950"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                爱丫爱丫影院
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              电视剧大全，全集免费在线观看。最新国产剧、韩剧全集高清不缓冲，流畅播放，秒开看剧。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4 whitespace-nowrap">影视分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4 whitespace-nowrap">热门推荐</h4>
            <ul className="space-y-2.5">
              <li><Link to="/detail/2" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">狂飙</Link></li>
              <li><Link to="/detail/1" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">长安十二时辰</Link></li>
              <li><Link to="/detail/3" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">黑暗荣耀</Link></li>
              <li><Link to="/detail/11" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">繁花</Link></li>
              <li><Link to="/detail/4" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">三体</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">联系我们</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 爱丫爱丫影院 版权所有 | 电视剧大全全集免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500/20 transition-colors duration-200 cursor-pointer">
              <i className="ri-wechat-line text-sm text-foreground-500"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500/20 transition-colors duration-200 cursor-pointer">
              <i className="ri-weibo-line text-sm text-foreground-500"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500/20 transition-colors duration-200 cursor-pointer">
              <i className="ri-bilibili-line text-sm text-foreground-500"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}